import React, { FC } from 'react';
import { Grid, GridProps, GridSpacing } from '@material-ui/core';
import styles from './styles.module.scss';
import { ListWithLoadMore, LoadMoreListConfig } from '../Common/ListWithLoadMore';
import { App } from '../../models/app';
import { AppCard } from '../AppCard';
import LoadingCard from '../AppCard/loadingCard';
import { EntityState } from '@reduxjs/toolkit';

interface ComponentProps {
  apps: Maybe<EntityState<App>>;
  loadMoreListConfig?: LoadMoreListConfig;
  isLoading: boolean;
  isFetching: boolean;
  gridProps?: GridProps;
  setApiLimit: (limit: number) => void | React.Dispatch<React.SetStateAction<number>>;
}

export const APP_GRID_LOAD_MORE_CONFIG: LoadMoreListConfig = {
  maxEntriesPerPage: 15,
  maxLimit: 60,
};

const GRID_PROPS: GridProps = {
  xs: 12,
  sm: 6,
  md: 4,
};

const RenderAppGridItem: FC<GridProps> = ({ children, ...rest }): JSX.Element => {
  return (
    <Grid item className={styles.gridItem} {...rest}>
      {children}
    </Grid>
  );
};

const RenderAppGridContainer: FC<{ spacing?: GridSpacing }> = ({ children, spacing = 2 }): JSX.Element => {
  return (
    <Grid container spacing={spacing} classes={{ root: styles.gridContainer }} data-testid="appGrid">
      {children}
    </Grid>
  );
};

export const AppGrid: FC<ComponentProps> = ({
  apps,
  loadMoreListConfig = APP_GRID_LOAD_MORE_CONFIG,
  gridProps = GRID_PROPS,
  isLoading,
  isFetching,
  setApiLimit,
}): JSX.Element => {
  return (
    <RenderAppGridContainer>
      <ListWithLoadMore<App>
        config={loadMoreListConfig}
        isLoading={isLoading}
        isFetching={isFetching}
        items={apps}
        setApiLimit={setApiLimit}
        renderItem={(app: Maybe<App>) => {
          if (!app) return;
          return (
            <RenderAppGridItem key={app.id} {...gridProps}>
              <AppCard app={app} />
            </RenderAppGridItem>
          );
        }}
        renderInitialLoader={index => {
          return (
            <RenderAppGridItem key={index} {...gridProps}>
              <LoadingCard />
            </RenderAppGridItem>
          );
        }}
      />
    </RenderAppGridContainer>
  );
};
